declare const window: any;

const track = (...args: any[]): void => {
    if (import.meta.env.VITE_FLYNT_ENV !== "production") {
        return;
    }

    if (!window.gtag) {
        return;
    }

    window.gtag(...args);
};

const pageview = (props: unknown): void => {
    track("config", import.meta.env.VITE_GA_MEASUREMENT_ID, props);
};

const event = (type: string, props: Record<string, any>): void => {
    track("event", type, props);
};

export default {
    pageview,
    event,
};
